import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommissionReportService {
  customerApi: string;

  constructor(private http: HttpClient) {
    this.customerApi = environment.customerApiUrl;
  }

  public getPartnerInfoCommission(params: any): Observable<any> {
    return this.http.post(`${this.customerApi}/partner-report/get-infomation-commission-statement`, params);
  }

  public getCommissionOfMonth(params: any): Observable<any> {
    return this.http.post(`${this.customerApi}/partner-report/get-commission-statement-of-month`, params);
  }

  public downloadCommissionPDF(params: any): Observable<any> {
    return this.http.post(`${this.customerApi}/partner-report/export-commission-statement-pdf`, params, {
      responseType: 'blob'
    });
  }

  public downloadCommissionExcel(params: any): Observable<any> {
    return this.http.post(`${this.customerApi}/partner-report/export-commission-statement-excel`, params, {
      responseType: 'blob'
    });
  }

  public downloadVATDocument(): Observable<any> {
    return this.http.get(`${this.customerApi}/customer/download-VAT-document`, {
      responseType: 'blob'
    });
  }

  public updateVATRegister(isVATRegistered: boolean): Observable<any> {
    return this.http.get(`${this.customerApi}/customer/update-VAT-registered/${isVATRegistered}`);
  }
}
